import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import cx from "classnames";

import Volume from "assets/images/sbs/volume.png";
import * as socketAction from "redux/sockets/action";

const VolumeSBS = (props) => {
  const [volumeDropdown, setvolumeDropdown] = useState(false);
  const volume_level = props?.socketReducer?.volume;

  const handleMute = () => {
    let volume = props?.socketReducer?.volume;
    if (volume !== 0) {
      props.setVolumeLevel(0);
    } else {
      props.setVolumeLevel(0.125);
    }
  };

  return (
    <>
      <div
        className={cx("volume-btn__wrapper", {
          volumeDropdown: volumeDropdown
        })}
      >
        <button
          className="volume-btn"
          onClick={() => {
            setvolumeDropdown(!volumeDropdown);
          }}
        >
          <img src={Volume} alt="Volume" />
        </button>
      </div>

      {volumeDropdown && (
        <div className="volume-modal">
          <h2 className="heading">Volume</h2>
          <div className="range-wraper">
            <button
              onClick={() => props.setVolumeLevel(0.125)}
              className={cx(
                "range",
                `${volume_level < 0.125 ? "disable-range" : ""}`
              )}
            >
              <div
                className={cx(
                  "range-inner inner1",
                  `${volume_level < 0.125 ? "disable-range" : ""}`
                )}
              ></div>
            </button>
            <button
              onClick={() => props.setVolumeLevel(0.25)}
              className={cx(
                "range",
                `${volume_level < 0.25 ? "disable-range" : ""}`
              )}
            >
              <div
                className={cx(
                  "range-inner inner2",
                  `${volume_level < 0.25 ? "disable-range" : ""}`
                )}
              ></div>
            </button>
            <button
              onClick={() => props.setVolumeLevel(0.375)}
              className={cx(
                "range",
                `${volume_level < 0.375 ? "disable-range" : ""}`
              )}
            >
              <div
                className={cx(
                  "range-inner inner3",
                  `${volume_level < 0.375 ? "disable-range" : ""}`
                )}
              ></div>
            </button>
            <button
              onClick={() => props.setVolumeLevel(0.5)}
              className={cx(
                "range",
                `${volume_level < 0.5 ? "disable-range" : ""}`
              )}
            >
              <div
                className={cx(
                  "range-inner inner4",
                  `${volume_level < 0.5 ? "disable-range" : ""}`
                )}
              ></div>
            </button>
          </div>
          <div className="mute-btn__wrapper">
            <button onClick={() => handleMute()} className="mute-btn">
              {volume_level < 0.1 ? "Unmute" : "Mute"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  socketReducer: state.socketReducer
});

const mapDispatchToProps = (dispatch) => ({
  setVolumeLevel: (data) => dispatch(socketAction.setVolumeLevel(data))
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(VolumeSBS);
